import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { GroupsContext } from '../../context/group/GroupContext';
import { AuthContext } from '../../context/auth';
import { BanksContext } from '../../context/bank/BankContext';

export const GroupPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;

    const { addGroup, updateGroup, groups } = useContext(GroupsContext);

    const [isFormValid, setIsFormValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const { user: loggedUser } = useContext(AuthContext);
    const { banks } = useContext(BanksContext)

    let group;

    if (state?.group) {
        group = state.group;
    } else {
        group = {
            group_id: -1,
            group_name: '',
            group_description: '',
            parent_group_id: null,
            is_payfac_group: 'N',
            bank_id: -1
        };
    }

    const { formState, onInputChange } = useForm(group);

    const {
        group_id,
        group_name,
        group_description,
        parent_group_id,
        is_payfac_group,
        bank_id
    } = formState;

    useEffect(() => {
        setIsFormValid(group_name.trim().length > 0);
    }, [group_name]);

    const handleSave = async () => {
        let resp = '';

        if (group_id > 0) {
            resp = await updateGroup(formState);
        } else {
            resp = await addGroup(formState);
        }

        if (resp === 'success') {
            setSuccessMessage(
                group_id > 0
                    ? 'Grupo actualizado correctamente'
                    : 'Grupo creado correctamente'
            );
        } else {
            setErrorMessage(resp);
        }
    };

    const removeError = () => setErrorMessage('');

    const removeSuccessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    };

    return (
        <div
            className="container d-flex align-items-center justify-content-center mt-5"
            style={styles.container}
        >
            <div className="col-md-6">
                <h3>{group_id > 0 ? 'Actualizar grupo' : 'Crear grupo'}</h3>
                <hr />

                <form className="row g-3">

                    <div className={`"mb-3 " ${loggedUser.groups[0].group_name == 'Administrator' ? '' : 'visually-hidden'}`}>
                        <label htmlFor="bankSelect" className="form-label">Banco</label>
                        <select id='bankSelect' className="form-select" name='bank_id' value={bank_id} onChange={onInputChange} disabled={group_id > 0}>
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {banks.length > 0
                                ?
                                banks.map(bank => (
                                    <option key={bank.id} value={bank.id} selected={bank.id == group.bank_id}>{bank.name}</option>
                                ))
                                :
                                <option selected>No hay bancos disponibles</option>
                            }
                        </select>
                    </div>

                    {/* Nombre */}
                    <div className="mb-3">
                        <label className="form-label">Nombre del grupo</label>
                        <input
                            type="text"
                            className={`form-control ${group_name ? 'is-valid' : 'is-invalid'}`}
                            name="group_name"
                            value={group_name}
                            onChange={onInputChange}
                            placeholder="Nombre del grupo"
                            required
                        />
                    </div>

                    {/* Descripción */}
                    <div className="mb-3">
                        <label className="form-label">Descripción</label>
                        <textarea
                            className="form-control"
                            name="group_description"
                            value={group_description}
                            onChange={onInputChange}
                            rows={3}
                            placeholder="Descripción del grupo (opcional)"
                        />
                    </div>

                    {/* Grupo padre */}
                    <div className="mb-3 visually-hidden">
                        <label className="form-label">Grupo padre</label>
                        <select
                            className="form-select"
                            name="parent_group_id"
                            value={parent_group_id ?? ''}
                            onChange={onInputChange}
                        >
                            <option value="">Sin grupo padre</option>
                            {groups
                                ?.filter(g => g.group_id !== group_id)
                                .map(g => (
                                    <option key={g.group_id} value={g.group_id}>
                                        {g.group_name}
                                    </option>
                                ))}
                        </select>
                    </div>

                    {/* Grupo padre */}
                    <div className="mb-3">
                        <label className="form-label">¿Es grupo usuarios payfac?</label>
                        <select
                            className="form-select"
                            name="is_payfac_group"
                            value={is_payfac_group ?? ''}
                            onChange={onInputChange}
                        >
                            <option value="N">No</option>
                            <option value="Y">Sí</option>
                        </select>
                    </div>

                    <div className="d-flex justify-content-center mt-4">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="btn btn-outline-secondary"
                        >
                            Atrás
                        </button>

                        <button
                            type="button"
                            onClick={handleSave}
                            className="btn btn-primary ms-4"
                            disabled={!isFormValid}
                        >
                            Guardar
                        </button>
                    </div>
                </form>
            </div>

            {errorMessage && (
                <Message
                    type="error"
                    message={errorMessage}
                    closeDialog={removeError}
                    handleOk={removeError}
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            )}

            {successMessage && (
                <Message
                    type="success"
                    title="Éxito"
                    message={successMessage}
                    closeDialog={removeSuccessMessage}
                    handleOk={removeSuccessMessage}
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            )}
        </div>
    );
};

const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
